import script from "./TaskHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskHeader.vue?vue&type=script&setup=true&lang=js"

import "./TaskHeader.vue?vue&type=style&index=0&id=cc0acdc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc0acdc8"]])

export default __exports__